import Overview from "./Overview";
import Curriculum from "./Curriculum";
import Instructor from "./Instructor";
import Support from "./Support";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../ui/tabs";
import {
  ListBulletIcon,
  Squares2X2Icon,
  UserIcon,
} from "@heroicons/react/24/outline";
import { Headset } from "lucide-react";
import mixpanel from "@/utils/mixpanel";
import { useState } from "react";
import { Bot, Square } from "lucide-react";

export function formatNumber(num: number) {
  const formats = [
    { value: 1e12, suffix: "t" },
    { value: 1e9, suffix: "b" },
    { value: 1e6, suffix: "m" },
    { value: 1e3, suffix: "k" },
  ];

  for (let i = 0; i < formats.length; i++) {
    if (num >= formats[i].value) {
      return (
        (num / formats[i].value).toFixed(1).replace(/\.0$/, "") +
        formats[i].suffix
      );
    }
  }

  return num.toString();
}

export default function BootcampTabs({
  bootcamp,
  years,
  starRating,
  reviews,
  students,
}: any) {

  const activeBatch = bootcamp.Batches.find(
    (batch: any) => batch.active
  ).Modules || [];

  const tabsData = {
    overview: {
      title: "Overview",
      mobIcon: <Squares2X2Icon className="w-5 h-5" />,
      mobIconFilled: <Squares2X2Icon className="w-5 h-5" fill="#9A7026" />,
      content: <Overview bootcamp={bootcamp} />,
    },
    curriculum: {
      title: "Curriculum",
      mobIcon: <UserIcon className="w-5 h-5" />,
      mobIconFilled: <UserIcon className="w-5 h-5" fill="#9A7026" />,
      content: <Curriculum Modules={activeBatch} />,
    },
    instructor: {
      title: "Instructor",
      mobIcon: <ListBulletIcon className="w-5 h-5" />,
      mobIconFilled: <ListBulletIcon className="w-5 h-5" fill="#9A7026" />,
      content: (
        <Instructor
          teacher={bootcamp.teacher}
          years={years}
          starRating={starRating}
          reviews={reviews}
          students={students}
        />
      ),
    },
    support: {
      title: "Support",
      mobIcon: <Headset className="w-5 h-5" />,
      mobIconFilled: <Headset className="w-5 h-5" fill="#9A7026" />,
      content: <Support />,
    },
  };

  const [activeTab, setActiveTab] = useState("overview");

  const handleTabClick = (tab: string) => {
    setActiveTab(tab);
    mixpanel.track(`bootcamp_${tab}_viewed`, {
      bootcamp: bootcamp?.title,
    });
  };

  return (
    <Tabs defaultValue="overview" className="w-full bg-[#EEEBE6]">
      <TabsList className="w-full sticky top-0 z-10 justify-start overflow-x-auto overflow-y-hidden h-16 bg-[#EEEBE6]">
        {Object.keys(tabsData).map((tab) => {
          const isActive = activeTab === tab;
          return (
            <TabsTrigger
              key={tab}
              className="w-full text-xl h-12 lg:min-w-36 border-0 data-[state=active]:border-b-2 bg-[#EEEBE6] data-[state=active]:border-[#9A7026] max-md:data-[state=active]:text-[#9A7026] data-[state=active]:font-semibold flex flex-col items-center max-lg:text-xs"
              value={tab}
              onClick={() => {
                handleTabClick(tab);
              }}
            >
              <span className="lg:hidden">
                {isActive
                  ? tabsData[tab as keyof typeof tabsData]?.mobIconFilled
                  : tabsData[tab as keyof typeof tabsData]?.mobIcon}
              </span>
              {tabsData[tab as keyof typeof tabsData]?.title}
            </TabsTrigger>
          );
        })}
      </TabsList>
      {Object.keys(tabsData).map((tab) => (
        <TabsContent key={tab} value={tab}>
          {tabsData[tab as keyof typeof tabsData]?.content}
        </TabsContent>
      ))}
    </Tabs>
  );
}
